import { Grid, Theme, useMediaQuery } from "@mui/material"
import ContainerContainer from "../../components/container/ContainerContainer"
import ContainerGridBar from "../../components/container/ContainerGridBar"
import ContainerGridTab from "../../components/container/ContainerGridTab"
import { useState } from "react"
import AdjudicationOncoming from "./tabs/AdjudicationOncoming"
import { AdjudicationsTabType } from "../../Store/Navigation/state"
import AdjudicationsSidebar from "./components/AdjudicationsSidebar"
import AdjudicationPendingTab from "./tabs/AdjudicationPendingTab"
import Authentication from "../../Store/Authentication/AuthenticationStore"
import AdjudicationDecisionSolvedTab from "./tabs/AdjudicationDecisionSolvedTab"
import AdjudicationSolvedTab from "./tabs/AdjudicationSolvedTab"


const Adjudications: React.FC = () => {

    const [tab, setTab] = useState<AdjudicationsTabType>(AdjudicationsTabType.ONCOMING)
    const breakpoint = useMediaQuery((theme: Theme) => theme.breakpoints.up('md'));
    
    const getTab = () => {
        switch(tab) {
            case AdjudicationsTabType.ONCOMING:
                return <AdjudicationOncoming/>
            case AdjudicationsTabType.PENDING:
                return <AdjudicationPendingTab/>
            case AdjudicationsTabType.SOLVED:
                return Authentication.isAdminAuthenticated()? <AdjudicationSolvedTab/> : <AdjudicationDecisionSolvedTab/> 
        }
    }

    return (
        <ContainerContainer>
            <Grid container style={{position: "relative"}}>
                <ContainerGridBar item md={2.5} xs={0}>
                    {breakpoint && (<AdjudicationsSidebar activeTab={tab} setTab={(tab) => setTab(tab)}/>)}
                </ContainerGridBar>
                <ContainerGridTab item md={9.5} xs={12}>
                    {getTab()}
                </ContainerGridTab>
            </Grid>
        </ContainerContainer>
    )
}

export default Adjudications